import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3l0 18","key":"svg-0"}],["path",{"d":"M16 7l0 10l5 0l-5 -10","key":"svg-1"}],["path",{"d":"M8 7l0 10l-5 0l5 -10","key":"svg-2"}]]

/**
 * IconFlipVertical
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZmxpcC12ZXJ0aWNhbCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgM2wwIDE4IiAvPgogIDxwYXRoIGQ9Ik0xNiA3bDAgMTBsNSAwbC01IC0xMCIgLz4KICA8cGF0aCBkPSJNOCA3bDAgMTBsLTUgMGw1IC0xMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/flip-vertical
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFlipVertical = createReactComponent('outline', 'flip-vertical', 'FlipVertical', __iconNode);

export default IconFlipVertical;